import { useEffect, useRef } from "react";

export default function useCallbackRef(callback = () => {}) {
  const callbackRef = useRef(callback || (() => {}));
  useEffect(() => {
    callbackRef.current = callback || (() => {});
  }, [callback]);
  return callbackRef;
}
